import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const BluetoothDongle = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <g fillRule="evenodd" clipRule="evenodd">
        <path d="M4.332.633h7.333v4H11V1.299h-6v3.334h-.667v-4Z" />
        <path d="M6.999 2.299v2h-.667v-2h.667ZM9.667 2.299v2H9v-2h.667ZM2.666 5.633h10.666v8.666a1.667 1.667 0 0 1-1.666 1.667H4.333a1.667 1.667 0 0 1-1.667-1.667V5.633Zm.667.666v8a1 1 0 0 0 1 1h7.333a1 1 0 0 0 1-1v-8H3.333Z" />
        <path d="M4.666 7.633h6.666v4.333H4.666V7.633Zm.667.666v3h5.333v-3H5.333Z" />
      </g>
    </svg>
  );
};

BluetoothDongle.category = 'product-category';

BluetoothDongle.displayName = 'BluetoothDongle';
